import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// This component listens for a change in the page (location)
// and scrolls the window to the top every time it changes.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // "document.documentElement.scrollTo" is the most reliable way to scroll
    // and works in all browsers.
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional: "smooth" for a scrolling effect
    });
  }, [pathname]); // The effect runs every time the a new page (pathname) is rendered

  return null; // This component doesn't render any visible HTML
}

export default ScrollToTop;
